/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export const useTasksStore = defineStore('tasksStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError,
      tasksList: []
    };
  },
  actions: {
    async listTasks() {
      try {
        if (this.tasksList.length) {
          return this.tasksList;
        }
        const response = await axios({
          url: '/tasks'
        });
        this.$patch({
          tasksList: response.data.tasks
        });
        return this.tasksList;
      } catch (error) {
        this.handleError(error);
        return [];
      }
    }
  }
});